var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14ffa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e584"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(-331 -200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 60,
    height: 60,
    rx: 20,
    transform: "translate(331 200)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_9025507_flower_icon",
    "data-name": "9025507_flower_icon",
    transform: "translate(337 206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 48,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(18.486 18.486)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M102.71,41.587C101.391,38.8,100,35.336,100,33.059a5.059,5.059,0,1,1,10.118,0c0,2.277-1.391,5.746-2.71,8.528",
    transform: "translate(-81.442 -22.941)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M49.961,75.973c-3.072-.235-6.776-.777-8.745-1.915a5.059,5.059,0,0,1,5.059-8.745c1.969,1.12,4.282,4.065,6.035,6.613",
    transform: "translate(-31.893 -52.736)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M50.134,133.247c-1.753,2.548-4.065,5.493-6.035,6.613a5.059,5.059,0,1,1-5.059-8.745c1.969-1.138,5.673-1.68,8.745-1.915",
    transform: "translate(-29.717 -105.198)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M107.408,152.8c1.319,2.783,2.71,6.252,2.71,8.528a5.059,5.059,0,1,1-10.118,0c0-2.277,1.391-5.746,2.71-8.528",
    transform: "translate(-81.442 -124.192)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M145.349,129.2c3.072.235,6.776.777,8.745,1.915a5.059,5.059,0,0,1-5.059,8.745c-1.969-1.12-4.282-4.065-6.035-6.613",
    transform: "translate(-116.394 -105.203)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M143,71.926c1.753-2.548,4.065-5.493,6.035-6.613a5.059,5.059,0,0,1,5.059,8.745c-1.969,1.138-5.673,1.68-8.745,1.915",
    transform: "translate(-116.394 -52.736)",
    fill: "none",
    stroke: "#117446",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/navIcon.c0394ab3d5f889dbfbd333f2e52f4cb0.svg";
export { ForwardRef as ReactComponent };